import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AUTH_LOGOUT } from "actions/auth";
import { INITIAL_SYNC_PRODUCTS } from "actions/sync-products";
import { INITIATE_STORES } from "actions/stores";
import Drawer from "components/Drawer";
import NotificationsDrawer from "components/NotificationsDrawer";
import CountryModal from "components/Header/CountryModal";
import Avatar from "@mui/material/Avatar";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MenuBarIcon from "assets/svg/MenuBarIcon";
import PersonIcon from "@mui/icons-material/Person";
import { ROUTES } from "shared/constants/routes";
import StyledBadge from "components/Header/StyledBadge";
import { getAllNotifications } from "actions/notifications";
import { fetchCart } from "actions/dtfCart";
import {
  Nav,
  Wrapper,
  Logo,
  Menu,
  UserName,
  CurrencyMenu,
  MobileMenu,
  ProfileImage,
  ProfileName,
  NotificationIcon,
  CartIcon,
} from "styles/components/Header";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currency = useSelector((state) => state?.currency?.value);
  const auth = useSelector((state) => state?.auth);
  const homeWebPage = useSelector((state) => state?.homeWebPage);
  const homeData = homeWebPage?.find((p) => p?.name === "Header") || {};
  const { components } = homeData;

  const [countryModalVisibility, updateCountryModalVisibility] =
    useState(false);
  const [drawerVisibility, updateDrawerVisibility] = useState(false);
  const toggleCountryModal = () =>
    updateCountryModalVisibility(!countryModalVisibility);
  const toggleDrawer = () => updateDrawerVisibility(!drawerVisibility);
  const profile = useSelector((state) => state?.auth?.profile);

  const [notificationDrawerVisibility, updateNotificationDrawerVisibility] =
    useState(false);
  const toggleNotificationDrawer = () =>
    updateNotificationDrawerVisibility(!notificationDrawerVisibility);

  const [notifications, setNotifications] = useState(null);
  const cartCount = useSelector((state) => {
    const cart = state?.dtfCart;
    return cart?.count ?? cart?.items?.length ?? 0;
  });
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const token = useSelector((state) => state?.auth?.profile?.token);
  const isAuthenticated = useSelector((state) => state?.auth?.authenticated);
  const showCartIcon = isAuthenticated;
  const handleCartClick = () => {
    navigate(ROUTES.DTF_TRANSFERS_CART.LINK);
  };

  const getNotificationsData = async () => {
    const data = await dispatch(getAllNotifications());
    setNotifications(() => data);
  };

  const { Image } = components || {};

  const ipUser = auth?.profile?.IPUser;

  useEffect(() => {
    getNotificationsData();
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated && emailid) {
      dispatch(fetchCart(emailid, token));
    }
  }, [dispatch, isAuthenticated, emailid, token]);

  return (
    <Fragment>
      <Nav>
        <Wrapper>
          {!ipUser && (
            <MenuBarIcon onClick={toggleDrawer} className="menu-bar-icon" />
          )}
          {Image && <Logo src={Image} alt="logo" />}
        </Wrapper>
        <Wrapper>
          <Menu>
            {showCartIcon ? (
              <CartIcon onClick={handleCartClick} aria-label="View cart">
                <StyledBadge
                  badgeContent={cartCount}
                  color="secondary"
                  showZero={false}
                >
                  <Avatar>
                    <ShoppingCartOutlinedIcon />
                  </Avatar>
                </StyledBadge>
              </CartIcon>
            ) : null}
            <NotificationIcon onClick={toggleNotificationDrawer}>
              <StyledBadge
                badgeContent={
                  notifications?.length ? `${notifications?.length}+` : "0"
                }
                color="secondary"
              >
                <Avatar>
                  <NotificationsActiveIcon className="notification-icon" />
                </Avatar>
              </StyledBadge>
            </NotificationIcon>
            {!ipUser && (
              <CurrencyMenu onClick={toggleCountryModal}>
                {currency === "USD" ? "US" : "CA"} Dollar
                <KeyboardArrowDownIcon style={{ color: "#ccc" }} />
              </CurrencyMenu>
            )}
            <UserName>
              <ProfileImage>
                <Avatar>
                  <PersonIcon />
                </Avatar>
              </ProfileImage>
              <ProfileName>
                <p>Hello</p>
                <p className="full-name">{profile?.FullName}</p>
              </ProfileName>
            </UserName>

            <Avatar>
              <PowerSettingsNewIcon
                className="logout-icon"
                onClick={() => {
                  dispatch({ type: INITIATE_STORES });
                  dispatch({ type: AUTH_LOGOUT });
                  dispatch({ type: INITIAL_SYNC_PRODUCTS });
                }}
              />
            </Avatar>
          </Menu>
          <MobileMenu>
            {showCartIcon ? (
              <CartIcon onClick={handleCartClick} aria-label="View cart">
                <StyledBadge
                  badgeContent={cartCount}
                  color="secondary"
                  showZero={false}
                >
                  <Avatar>
                    <ShoppingCartOutlinedIcon />
                  </Avatar>
                </StyledBadge>
              </CartIcon>
            ) : null}
            <ProfileName>
              <p>Hello</p>
              <p className="full-name">{profile?.FullName}</p>
            </ProfileName>
          </MobileMenu>
        </Wrapper>
      </Nav>
      {countryModalVisibility && (
        <CountryModal
          open={countryModalVisibility}
          onClose={toggleCountryModal}
        />
      )}

      {drawerVisibility && (
        <Drawer open={drawerVisibility} toggle={toggleDrawer} />
      )}

      <NotificationsDrawer
        open={notificationDrawerVisibility}
        toggle={toggleNotificationDrawer}
      />
    </Fragment>
  );
};

export default Header;
